import { render, staticRenderFns } from "./toUseBtn.vue?vue&type=template&id=6cc0a72a&scoped=true&"
import script from "./toUseBtn.vue?vue&type=script&lang=js&"
export * from "./toUseBtn.vue?vue&type=script&lang=js&"
import style0 from "./toUseBtn.vue?vue&type=style&index=0&id=6cc0a72a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc0a72a",
  null
  
)

export default component.exports